import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "cancelary-text-button",
  templateUrl: "./cancelary-text-button.component.html",
})
export class CancelaryTextButtonComponent {
  @Input() public disabled: boolean;
  @Input() public noLeftPadding: boolean;
  @Input() public noRightMargin: boolean = false;
  @Input() public selected: boolean;
  @Output() public onClick = new EventEmitter();
}
